var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYearnLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 0C74.5056 0 96 21.4944 96 48C96 74.5056 74.5056 96 48 96C21.4944 96 0 74.5056 0 48C0 21.4944 21.4944 0 48 0Z",
    fill: "#006AE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0225 68.2368V28.3008H50.3712V68.2368H46.0225Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1599 41.6073L54.7295 45.1689L51.7343 31.2297L55.7279 30.3273L57.3023 36.9321C57.3023 36.9321 60.9311 30.9801 56.0927 24.8169C53.2415 21.6489 51.8879 21.5145 48.6911 21.0153C45.8784 20.6121 39.3408 21.5625 37.392 29.1945C36.5664 34.1097 37.4976 37.7481 43.8335 42.5097L43.4783 47.8089C43.4783 47.8089 36.4032 42.8265 34.5792 39.3321C33.168 36.5673 30.7488 31.1049 35.1168 23.5017C37.4688 19.7001 42.1056 16.0521 50.2751 16.4361C54.3839 16.6089 64.4159 21.6297 62.8607 33.3609C62.5919 35.5593 61.4495 38.4873 61.4495 38.4873L66.9599 37.2585L68.1599 41.6073Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4896 72.8542C58.032 76.5886 53.2992 80.1117 45.1488 79.5165C41.04 79.2381 31.152 73.9485 33.0144 62.2654C33.3408 60.0766 34.56 57.187 34.56 57.187L29.0208 58.2622L27.936 53.8942L41.4624 50.6878L44.0928 64.7038L40.0704 65.5006L38.6688 58.8478C38.6688 58.8478 34.8864 64.6942 39.552 70.9918C42.3168 74.2366 43.6608 74.3997 46.8576 74.9853C49.6512 75.4653 56.2176 74.6782 58.368 67.1038C59.3184 62.2174 58.4832 58.5502 52.2816 53.6158L52.7808 48.3262C52.7808 48.3262 59.7216 53.491 61.4496 57.0334C62.7744 59.8462 65.0496 65.3758 60.4896 72.8542Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearnLogo);
export default __webpack_public_path__ + "static/media/yearn-logo.d4a8167e1303faa28f27ab72c4ca0b7d.svg";
export { ForwardRef as ReactComponent };